declare const APP_VERSION: string;
declare const APP_RELEASEDATE: string;

export const environment = {
  production: true,
  serviceWorker: true,
  version: APP_VERSION || '0.0.0',
  releaseDate: APP_RELEASEDATE || '0000-00-00',
  clientId: '87f5fb78-92d1-4bd4-8ce0-c9922121d121',
  authority:
    'https://businessoneservice.b2clogin.com/businessoneservice.onmicrosoft.com/B2C_1A_signup_signin',
  authoritySignUp:
    'https://businessoneservice.b2clogin.com/businessoneservice.onmicrosoft.com/B2C_1A_signup',
  authorityPasswordReset:
    'https://businessoneservice.b2clogin.com/businessoneservice.onmicrosoft.com/B2C_1A_PasswordReset',
  redirectUri: '',
  knownAuthorities: ['businessoneservice.b2clogin.com'],
  apiScopes: ['https://businessoneservice.onmicrosoft.com/api/All'],

  businessoneioAppId: 'business-one.io-einvoice',
  apiBase: 'business-one.io',
  gaMeasurementId: 'G-TRRF2XMJE3',
};
